<template>
    <nav :class="user ? 'sticky pin-t z-10' : ''">
        <div class="px-4 bg-white border-b">
            <div class="container flex items-center justify-between flex-wrap mx-auto">
                <div class="flex items-center flex-no-shrink mr-6">
                    <router-link class="font-thin text-2xl no-underline tracking-wide text-grey-dark"
                        :to="{ name: 'home' }">
                        {{ env.VUE_APP_NAME }}
                    </router-link>
                </div>
                <!--<div class="block md:hidden">
                    <button class="flex items-center px-3 py-2 border rounded text-teal-lighter border-teal-light hover:text-white hover:border-white">
                        <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
                    </button>
                </div> -->
                <div v-if="!user"
                    class="py-4 w-full block flex-grow md:flex md:items-center md:w-auto md:justify-end">
                    <a href="https://www.laragle.com" target="_blank" class="hover:text-blue mr-6 no-underline text-grey-dark">Blog</a>
                    <router-link class="hover:text-blue mr-6 no-underline text-grey-dark"
                        :to="{ name: 'pricing' }">Pricing</router-link>
                    <router-link class="hover:text-blue mr-6 no-underline text-grey-dark"
                        :to="{ name: 'login' }">Log In</router-link>
                    <router-link class="no-underline bg-blue px-4 py-2 rounded text-white"
                        :to="{ name: 'signup' }">Sign Up</router-link>
                </div>
                <div v-else>
                    <popper class="float-right"
                        trigger="click"
                        :options="{placement: 'bottom-start'}">
                        <template slot="reference">
                            <a class="cursor-pointer py-5 inline-flex items-center">
                                <span>{{ user.first_name }}</span>
                                <arrow-dropdown-icon/>
                            </a>
                        </template>
                        <div class="dropdown-menu text-grey-darker">
                            <router-link :to="{name: 'settings.profile'}"
                                class="dropdown-item no-underline text-grey-darker"
                                v-if="user.email_confirmed_at != null">Settings</router-link>
                            <a class="dropdown-item"
                                @click="logout">
                                Logout
                            </a>
                        </div>
                    </popper>
                </div>
            </div>
        </div>
        <div class="bg-green-lighter p-4"
            v-if="successMessage">
            <div class="container mx-auto"
                v-html="successMessage"></div>
        </div>
        <div class="bg-red p-4"
            v-if="errorMessage">
            <div class="container mx-auto text-white"
                v-html="errorMessage"></div>
        </div>
    </nav>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        data() {
            return {
                env: process.env
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
                successMessage: 'headerSuccessMessage',
                errorMessage: 'headerErrorMessage'
            })
        },
        methods: {
            logout() {
                this.$store.commit('setLoading', true);
                this.$store.dispatch('auth/logout')
                    .then(() => {
                        this.$router.push({ name: 'login' })
                        this.$store.commit('client/setClients', [])
                        this.$store.commit('client/setClient', { languages: [] })
                        this.$store.commit('setLoading', false)
                    })
                    .catch(() => {
                        this.$store.commit('setLoading', false)
                    })
            }
        },
        updated() {
            setTimeout(() => {
                if (this.successMessage) {
                    this.$store.commit('setHeaderSuccessMessage', null)
                }

                if (this.errorMessage) {
                    this.$store.commit('setHeaderErrorMessage', null)
                }
            }, 5000)
        }
    }
</script>